document.addEventListener("DOMContentLoaded", () => {
    const sendBtn = document.getElementById("chat-send");
    const input   = document.getElementById("chat-input");
    const box     = document.getElementById("chat-messages");

    if (!sendBtn) return;

    function appendMessage(who, text) {
        const wrapper = document.createElement("div");
        wrapper.className = who === "user" ? "d-flex justify-content-end mb-10" : "d-flex justify-content-start mb-10";

        if (who === "user") {
            wrapper.className = "d-flex justify-content-end mb-10";
            wrapper.innerHTML = `
              <div class="d-flex flex-column align-items-start">
                <div class="d-flex align-items-center mb-2">
                  <div class="ms-3">
                    <a href="#" class="fs-5 fw-bold text-gray-900 text-hover-primary me-1">Tú</a>
                  </div>
                </div>

                <div class="p-5 rounded bg-light-info text-gray-900 fw-semibold mw-lg-400px text-start" data-kt-element="message-text">
                  ${text}
                </div>
              </div>
            `;
        } else {
            texto = text.replace(/\n/g, "<br><br>");
            texto = texto.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");

            wrapper.className = "d-flex justify-content-start mb-10";
            wrapper.innerHTML = `
              <div class="d-flex flex-column align-items-end">
                <div class="d-flex align-items-center mb-2">
                  <div class="me-3">
                    <a href="#" class="fs-5 fw-bold text-gray-900 text-hover-primary ms-1">Asistente</a>
                  </div>
                </div>
                <div class="p-5 rounded bg-light-primary text-gray-900 fw-semibold mw-lg-400px text-end" data-kt-element="message-text">
                  ${texto}
                </div>
              </div>
            `;
        }

        box.append(wrapper);
        box.scrollTop = box.scrollHeight;
    }

    async function sendMessage() {
        const text = input.value.trim();
        if (!text) return;
        appendMessage("user", text);
        input.value = "";
        // Aviso de “pensando…”
        appendMessage("bot", "<em>Pensando…</em>");

        try {
            const res = await fetch("/ai_chat", {
                method: "POST",
                headers: { "Content-Type": "application/json", "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content },
                body: JSON.stringify({ message: text })
            });
            const json = await res.json();
            // Eliminar “Pensando…”
            box.lastChild.remove();
            box.scrollTop = box.scrollHeight;
            console.log("√√jsonjsonjsonjson")
            console.log(json)

            if (json.error) {
                appendMessage("bot", `<span class="text-danger">Error: ${json.error}</span>`);
            } else {
                appendMessage("bot", json.reply.text);
                if (json.reply.chart_data) {
                    const chartId = "chartdiv-" + Date.now(); // id único
                    const chartContainer = document.getElementById("charts-container");
                    chartContainer.innerHTML += `<div id="${chartId}" style="width:100%; height:400px; margin-top:20px;"></div>`;

                    // Dibujar gráfico
                    drawChart(chartId, json.reply.chart_data);
                }
            }
        } catch (e) {
            appendMessage("bot", `<span class="text-danger">Error al conectar con el servidor.</span>`);
        }
    }

    sendBtn.addEventListener("click", sendMessage);
    input.addEventListener("keypress", (e) => {
        if (e.key === "Enter") sendMessage();
    });

    var initDaterangepicker = () => {
        var start = moment().subtract(29, "days");
        var end = moment();
        var input = $("#kt-daterangepicker");

        function cb(start, end) {
            input.html(start.format("MMMM D, YYYY") + " - " + end.format("MMMM D, YYYY"));
        }

        input.daterangepicker({
            startDate: start,
            endDate: end,
            ranges: {
                "Hoy": [moment(), moment()],
                "Ayer": [moment().subtract(1, "days"), moment().subtract(1, "days")],
                "Últimos 7 días": [moment().subtract(6, "days"), moment()],
                "Últimos 30 días": [moment().subtract(29, "days"), moment()],
                "Mes Actual": [moment().startOf("month"), moment().endOf("month")],
                "Mes Pasado": [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")]
            },
            "locale": {
                "format": "DD/MM/YYYY",
                "separator": " - ",
                "applyLabel": "Aplicar",
                "cancelLabel": "Cancelar",
                "fromLabel": "De",
                "toLabel": "A",
                "customRangeLabel": "Personalizado",
                "weekLabel": "S",
                "daysOfWeek": [
                    "Do",
                    "Lu",
                    "Ma",
                    "Mi",
                    "Ju",
                    "Vi",
                    "Sa"
                ],
                "monthNames": [
                    "Enero",
                    "Febrero",
                    "Marzo",
                    "Abril",
                    "Mayo",
                    "Junio",
                    "Julio",
                    "Agosto",
                    "Septiembre",
                    "Octubre",
                    "Noviembre",
                    "Deciembre"
                ],
                "firstDay": 1
            },
        }, cb);

        cb(start, end);
    }

    function drawBalanceChart() {
        const graficaEl = document.querySelector("#grafica")
        if (!graficaEl) return

        const data = JSON.parse(graficaEl.dataset.unidades)

        console.log("datadatadatadatadata")
        console.log(data)

        const familias = data.map(d => d.FAMILIA)
        const ejercido = data.map(d => d.EJERCIDO)
        const presupuesto = data.map(d => d.PRESUPUESTO)

        const options = {
            chart: {
                type: 'line',
                height: 400,
                toolbar: { show: false },
                background: '#fff',
                zoom: {
                    enabled: false
                },
            },
            stroke: {
                width: [3, 3],
                dashArray: [0, 8]
            },
            colors: ['#008FFB', '#FEB019'],
            series: [
                { name: 'EJERCIDO', data: ejercido },
                { name: 'PRESUPUESTO', data: presupuesto }
            ],
            xaxis: {
                categories: familias,
                labels: { rotate: -45 }
            },
            yaxis: {
                title: { text: 'Monto ($)' }
            },
            title: {
                text: 'Comparativo Presupuesto vs Ejercido por Familia',
                align: 'center'
            },
            tooltip: {
                y: {
                    formatter: value => '$' + value.toLocaleString()
                }
            },
            legend: {
                position: 'top'
            }
        }

        const chart = new ApexCharts(graficaEl, options)
        chart.render()
    }

    function drawChart(chartId, chartData) {
        const chartsContainer = document.getElementById("charts-container");

        // 🔥 Eliminar cualquier gráfico previo (roots y divs)
        am5.registry.rootElements.forEach(root => root.dispose());
        chartsContainer.innerHTML = "";

        // Crear un nuevo div dentro del contenedor
        const newDiv = document.createElement("div");
        newDiv.id = chartId;
        newDiv.style.width = "100%";
        newDiv.style.height = "400px";
        newDiv.style.marginTop = "20px";
        chartsContainer.appendChild(newDiv);

        let root = am5.Root.new(chartId);
        root.setThemes([am5themes_Animated.new(root)]);

        let chart;

        if (chartData.type === "bar") {
            chart = root.container.children.push(
                am5xy.XYChart.new(root, { panX: true, panY: true, wheelX: "panX", wheelY: "zoomX" })
            );

            let xAxis = chart.xAxes.push(
                am5xy.CategoryAxis.new(root, {
                    categoryField: "label",
                    renderer: am5xy.AxisRendererX.new(root, { minGridDistance: 30 })
                })
            );

            let yAxis = chart.yAxes.push(
                am5xy.ValueAxis.new(root, { renderer: am5xy.AxisRendererY.new(root, {}) })
            );

            let series = chart.series.push(
                am5xy.ColumnSeries.new(root, {
                    name: "Series 1",
                    xAxis,
                    yAxis,
                    valueYField: "value",
                    categoryXField: "label"
                })
            );

            let data = chartData.labels.map((label, i) => ({
                label,
                value: chartData.values[i]
            }));

            xAxis.data.setAll(data);
            series.data.setAll(data);

        } else if (chartData.type === "line") {
            chart = root.container.children.push(am5xy.XYChart.new(root, {}));

            let xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(root, { categoryField: "label" }));
            let yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {}));

            let series = chart.series.push(
                am5xy.LineSeries.new(root, {
                    xAxis,
                    yAxis,
                    valueYField: "value",
                    categoryXField: "label"
                })
            );

            let data = chartData.labels.map((label, i) => ({
                label,
                value: chartData.values[i]
            }));

            xAxis.data.setAll(data);
            series.data.setAll(data);

        } else if (chartData.type === "pie") {
            chart = root.container.children.push(am5percent.PieChart.new(root, {}));

            let series = chart.series.push(am5percent.PieSeries.new(root, {
                valueField: "value",
                categoryField: "label"
            }));

            let data = chartData.labels.map((label, i) => ({
                label,
                value: chartData.values[i]
            }));

            series.data.setAll(data);
        }
    }

    document.querySelectorAll(".chartdiv").forEach((el) => {
        // ⚠️ Tiny Slider clona slides. Evitamos inicializar gráficos en los clones.
        if (el.closest(".tns-slide-cloned")) return;

        // Asegurarse que es un elemento válido
        if (!(el instanceof HTMLElement)) return;

        // Eliminar root anterior si existe
        if (el.am5Root) {
            el.am5Root.dispose();
            el.am5Root = null;
        }

        let sucursales;
        try {
            sucursales = JSON.parse(el.dataset.sucursales || "[]");
        } catch (e) {
            console.error("JSON inválido en", el.id, e);
            return;
        }

        // No inicializar si no hay datos
        if (!Array.isArray(sucursales) || sucursales.length === 0) return;

        // Crear nuevo Root
        const root = am5.Root.new(el);
        el.am5Root = root;

        root.setThemes([am5themes_Animated.new(root)]);

        // Crear chart
        const chart = root.container.children.push(
            am5xy.XYChart.new(root, {
                panX: true,
                panY: true,
                wheelX: "panX",
                wheelY: "zoomX",
                layout: root.verticalLayout
            })
        );

        // Eje X
        const xAxis = chart.xAxes.push(
            am5xy.CategoryAxis.new(root, {
                categoryField: "sucursal",
                renderer: am5xy.AxisRendererX.new(root, { minGridDistance: 30 })
            })
        );
        xAxis.get("renderer").labels.template.setAll({
            rotation: -90,
            centerY: am5.p50,
            centerX: am5.p100,
            textAlign: "right",
        });
        xAxis.data.setAll(sucursales);

        // Eje Y
        const yAxis = chart.yAxes.push(
            am5xy.ValueAxis.new(root, {
                renderer: am5xy.AxisRendererY.new(root, {})
            })
        );

        // Serie Presupuesto (Column)
        const seriesPresupuesto = chart.series.push(
            am5xy.ColumnSeries.new(root, {
                name: "Ingreso",
                xAxis: xAxis,
                yAxis: yAxis,
                valueYField: "presupuesto",
                categoryXField: "sucursal",
                tooltip: am5.Tooltip.new(root, {
                    labelText: "{name}: {valueY}"
                })
            })
        );
        seriesPresupuesto.data.setAll(sucursales);

        // Serie Ejercido (Line)
        const seriesEjercido = chart.series.push(
            am5xy.LineSeries.new(root, {
                name: "Egreso",
                xAxis: xAxis,
                yAxis: yAxis,
                valueYField: "ejercido",
                categoryXField: "sucursal",
                stroke: am5.color(0xff0000),
                tooltip: am5.Tooltip.new(root, {
                    labelText: "{name}: {valueY}"
                })
            })
        );
        seriesEjercido.strokes.template.setAll({ strokeWidth: 2 });
        seriesEjercido.bullets.push(() => {
            return am5.Bullet.new(root, {
                sprite: am5.Circle.new(root, {
                    radius: 5,
                    fill: seriesEjercido.get("stroke")
                })
            });
        });
        seriesEjercido.data.setAll(sucursales);

        // Cursor y leyenda
        chart.set(
            "cursor",
            am5xy.XYCursor.new(root, {
                behavior: "none",
                xAxis: xAxis
            })
        );

        chart.children.push(
            am5.Legend.new(root, {
                centerX: am5.p50,
                x: am5.p50
            })
        ).data.setAll([seriesPresupuesto, seriesEjercido]);
    });


    initDaterangepicker();
    drawBalanceChart();
});
